// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1AGFE","empty":"ModalGraph_empty__2ckt7"};